import { Link, useLocation } from "react-router-dom";
import { useState, useRef, useEffect } from "react";
import { BsArrowRight } from "react-icons/bs";
import {
  TextField, Button, Typography, Box, Snackbar,
  Alert, Backdrop, CircularProgress, Grid, Container,
  MenuItem,FormControl,InputLabel,Select
} from "@mui/material";
import { investorApi } from "../../api/api";
import FileUploadWithPreview from "../common/FileUploadWithPreview"; // Assuming this is your file upload component

const EditTeam = () => {
  const location = useLocation();
  const { Id,MemberName, description, specialization, IconUrl,Mobilenumber,email ,Status} = location.state || {}; 
  const [memberValue, setmemberName] = useState(MemberName || '');
  const [descriptionValue, setDescription] = useState(description || '');
  const [specificationValue, setSpecification] = useState(specialization || '');
  const [contact_number,setContactNumber]=useState(Mobilenumber||"");
  const [emailValue,setEmail]=useState(email||"");
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [propertyErrors, setPropertyErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
   const [status,setStatus]=useState(Status); 
  
  const fileInputRef = useRef();

  useEffect(() => {
    // If there's an existing image URL, use it as a preview
    if (files.length === 0 && IconUrl) {
      setPreviews([IconUrl]); // Use the existing image URL as the preview
    }
  }, [IconUrl]);

  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files);
    if (selectedFiles.length > 1) {
      setSnackbarMessage("You can only select one image.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
      return;
    }
    const newFile = selectedFiles[0];
    const newPreview = URL.createObjectURL(newFile);
    setFiles([newFile]);
    setPreviews([newPreview]);
    event.target.value = null;  // Reset file input value after selection
  };

  const handleRemove = () => {
    setFiles([]);  // Clear the files
    setPreviews([]);  // Clear previews
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'memberValue') {
      setmemberName(value);
    } else if (name === 'descriptionValue') {
      setDescription(value);
    } else if (name === 'specificationValue') {
      setSpecification(value);
    } 
    else if(name === 'contact_number') {
      setContactNumber(value);
    }
    else if(name === 'emailValue') {
      setEmail(value);
    }
   

  };

  const validate = () => {
    let isValid = true;
    const errors = {}; // to store error messages
    // Validate Project Name
    if (!memberValue || memberValue.trim() === '') {
      errors.memberValue = 'Member name is required.';
      isValid = false;
    }
    // Validate Address
    if (!specificationValue || specificationValue.trim() === '') {
      errors.specificationValue = 'Experience field is required.';
      isValid = false;
    }
    // Validate City
    if (!descriptionValue || descriptionValue.trim() === '') {
      errors.cityValue = 'City field is required.';
      isValid = false;
    }
    if(!contact_number || contact_number.trim() === '') {
      errors.contactnumber = 'Contact number field is required';
      isValid = false;
    }
    if(!emailValue || emailValue.trim()==='') {
      errors.emailValue = 'Email field is required';
    }
    if(!status || status.trim()==='') {
      errors.status = 'Status field is required';
    }
    // If there are errors, set them to state for feedback
    setPropertyErrors(errors);
    return isValid;
  };

  const saveTeam = async (event) => {
    event.preventDefault();
    // Validate inputs before proceeding
    if (!validate()) return;
  
    setLoading(true);
    
    // Create FormData object to append form fields
    const formData = new FormData();
    formData.append("Id",Id);
    formData.append("name", memberValue);
    formData.append("specialization", specificationValue);
    formData.append("description", descriptionValue);
    formData.append("contact_number",contact_number);
    formData.append("email",emailValue);
    formData.append('status',status);
    
  
    // Append the file name (not the file itself)
    if (files.length > 0) {
      const fileName = files[0].name; // Get the name of the selected file
      formData.append("image", files[0]); // Send only the file name to the backend
    } 
  
    // Log FormData for debugging purposes
    for (let pair of formData.entries()) {
      console.log(pair[0] + ": " + pair[1]);
    }
  
    // Simulate saving data and show loading state
    try {
      const response = await investorApi.updateLegalTeam(formData);
      setSnackbarMessage("Team edited successfully!");
      setSnackbarSeverity("success");
      setSnackbarOpen(true);
    } catch (error) {
      console.error("Error Editing Team", error);
      setSnackbarMessage("Failed to edit team. Please try again.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    } finally {
      setLoading(false);
    }
  };
  

  const editCancelTeam = () => {
    window.location.href = "/team";  // Redirect to the properties list
  };

  return (
    <Container sx={{ py: 5, maxWidth: "80%" }}>
      {/* Loader */}
      <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
        <CircularProgress color="inherit" />
      </Backdrop>

      {/* Snackbar */}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>

      <Box
        sx={{
          margin: "2rem auto",
          padding: "2rem",
          borderRadius: "10px",
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          backgroundColor: "#fff",
          maxWidth: '80%',
        }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 4 }}>
          <Typography variant="h4" component="h1" sx={{ color: '#13216E', fontWeight: 600, fontSize: '24px' }}>
            Edit Team
          </Typography>
          <Box>
            <Link to="/team" style={{ textDecoration: "none", color: '#4E0DFF', fontSize: '18px' }}>
              Home
            </Link>
            <BsArrowRight style={{ margin: "-2px 8px", color: "#4E0DFF" }} />
            <Link to="#" style={{ textDecoration: "none", color: "#4E0DFF", fontSize: '18px' }}>
              Team
            </Link>
          </Box>
        </Box>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Member Name"
              variant="outlined"
              name="memberValue"
              value={memberValue}
              onChange={handleInputChange}
              required
              error={!!propertyErrors.memberValue} 
              helperText={propertyErrors.memberValue} 
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="text"
              label="Description"
              variant="outlined"
              name="descriptionValue"
              value={descriptionValue}
              onChange={handleInputChange}
              required
              error={!!propertyErrors.descriptionValue}
              helperText={propertyErrors.descriptionValue}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="text"
              label="Specialization"
              variant="outlined"
              name="specificationValue"
              value={specificationValue}
              onChange={handleInputChange}
              required
              error={!!propertyErrors.specificationValue}
              helperText={propertyErrors.specializationValue}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="number"
              label="Contact number"
              variant="outlined"
              name="contact_number"
              value={contact_number}
              onChange={handleInputChange}
              required
              error={!!propertyErrors.contactnumber}
              helperText={propertyErrors.contactnumber}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              type="text"
              label="Email"
              variant="outlined"
              name="emailValue"
              value={emailValue}
              onChange={handleInputChange}
              required
              error={!!propertyErrors.emailValue}
              helperText={propertyErrors.emailValue}
            />
          </Grid>
           <Grid item xs={12}>
                            <FormControl fullWidth>
                                <InputLabel> Status </InputLabel>
                                <Select
                                  value={status}
                                  onChange={(e)=>setStatus(e.target.value)}
                                  label="Status"
                                  error={!!propertyErrors.status}
                                >
                                  
                   <MenuItem value="Active"> Active</MenuItem>
                    <MenuItem value="InActive"> InActive</MenuItem>
                  

                                </Select>
                            </FormControl>
                        </Grid>
          {/* File Upload */}
          <Grid item xs={12}>
            <FileUploadWithPreview
              handleFileChange={handleFileChange}
              handleRemove={handleRemove}
              previews={previews}
              files={files}
              fileInputRef={fileInputRef}
            />
          </Grid>
          <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 2 }}>
            <Button variant="contained" color="primary" onClick={saveTeam} disabled={loading}>
              {loading ? "Saving..." : "Save"}
            </Button>
            <Button variant="outlined" color="secondary" onClick={editCancelTeam}>
              Cancel
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default EditTeam;